import React, { useEffect } from "react";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import HomePage from './components/Homepage';
import PlacesPage from './components/PlacesPage'; 
import ThingsPage from './components/ThingsPage'; 
import Login from './components/login';
import SignUp from './components/register';
import Profile from './components/UserProfile';
import AuthLayout from './components/AuthLayout';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 

import { useState } from "react";
import { auth } from "./utils/firebase";
import TulayZapote from "./pages/TulayZapote";
import MolinoDam from "./pages/MolinoDam";
import StrikeGym from "./pages/StrikeGym";
import SenyongsMuseum from "./pages/SenyongsMuseum";
import BacoorPark from "./pages/BacoorPark";
import PrinzaDam from "./pages/PrinzaDam";
import MarianoGomes from "./pages/MarianoGomes";
import './styles/App.css'; 
import ArtsMonuments from "./pages/ArtsMonuments"; 
import ScrollToTop from './components/ScrollToTop';
import KainanBalsa from "./pages/KainansaBalsa"; 
import SeafoodTerminal from "./pages/SeafoodTerminal"; 
import DigmanHalo from "./pages/DigmanHalo"; 
import MonumentLove from "./pages/MonumentLove"; 
import EdilbertoMonument from "./pages/EdilbertoMonument"; 
import Ginintuan from './pages/Ginintuan';
import BahayTisa from './pages/BahayTisa';
import JusticeHouse from './pages/JusticeHouse';
import MichaelChurch from './pages/MichaelChurch';
import UnidaChurch from './pages/UnidaChurch';
import SMBacoor from './pages/SMBacoor';
import StEzekiel from './pages/stezekiel';
import SMMolino from './pages/SMMolino';
import NOMO from './pages/NOMO';
import StoNino from './pages/StoNino';
import SOMO from './pages/SOMO';
import RFCMall from './pages/RFCMall';
import MainSquare from './pages/MainSquare';
import RAntonio from './pages/RAntonio';
import Funnside from './pages/Funnside';
import Brickwood from './pages/Brickwood';
import Cocina from './pages/Cocina';
import Cvsu from './pages/Cvsu';



import AnnouncementDetail from "./components/announcements/AnnouncementDetail";




import AdminUsers from './components/admin/AdminUsers'; 
import AdminPosts from './components/admin/AdminPosts';
import AdminFeedback from './components/admin/AdminFeedback';
import UserArchive from './components/admin/UserArchive';
import PostsArchive from './components/admin/PostsArchive';
import FeedbackArchive from './components/admin/FeedbackArchive';
import BridgesAdmin from './components/admin/BridgesAdmin';
import MonumentsAdmin from './components/admin/MonumentsAdmin';
import RecreationalAdmin from './components/admin/RecreationalAdmin';
import DiningAdmin from './components/admin/DiningAdmin';
import AnnouncementAdmin from './components/admin/AnnouncementAdmin';
import AnnouncementArchive from './components/admin/AnnouncementArchive';
import ExploreAboutAdmin from './components/admin/ExploreAboutAdmin';
import HouseAdmin from './components/admin/HouseAdmin';
import ChurchesAdmin from './components/admin/ChurchesAdmin';
import ShoppingAdmin from './components/admin/ShoppingAdmin';
import ProtectedAdminRoute from "./components/admin/ProtectedAdminRoute"; // adjust path



import Culture from './components/sliders/Culture';
import Community from './components/sliders/Community';
import Festival from './components/sliders/Festival';




function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setUser(user);
    });

    return () => unsubscribe(); // Clean up subscription on unmount
  }, []);


  return (
    
    <Router>
      <ScrollToTop />
      <div className="App">
      <ToastContainer /> 
        <Routes>
          
          <Route path="/adminusers" element={<ProtectedAdminRoute><AdminUsers /></ProtectedAdminRoute>} />
          <Route path="/adminposts" element={<ProtectedAdminRoute><AdminPosts /></ProtectedAdminRoute>} />
          <Route path="/adminfeedback" element={<ProtectedAdminRoute><AdminFeedback /></ProtectedAdminRoute>} />
          <Route path="/userarchive" element={<ProtectedAdminRoute><UserArchive /></ProtectedAdminRoute>} />
          <Route path="/postsarchive" element={<ProtectedAdminRoute><PostsArchive /></ProtectedAdminRoute>} />
          <Route path="/feedbackarchive" element={<ProtectedAdminRoute><FeedbackArchive /></ProtectedAdminRoute>} />
          <Route path="/bridgesadmin" element={<ProtectedAdminRoute><BridgesAdmin /></ProtectedAdminRoute>} />
          <Route path="/monumentsadmin" element={<ProtectedAdminRoute><MonumentsAdmin /></ProtectedAdminRoute>} />
          <Route path="/recreationaladmin" element={<ProtectedAdminRoute><RecreationalAdmin /></ProtectedAdminRoute>} />
          <Route path="/diningadmin" element={<ProtectedAdminRoute><DiningAdmin /></ProtectedAdminRoute>} />
          <Route path="/announcementadmin" element={<ProtectedAdminRoute><AnnouncementAdmin /></ProtectedAdminRoute>} />
          <Route path="/announcementarchive" element={<ProtectedAdminRoute><AnnouncementArchive /></ProtectedAdminRoute>} />
          <Route path="/exploreaboutadmin" element={<ProtectedAdminRoute><ExploreAboutAdmin /></ProtectedAdminRoute>} />
          <Route path="/houseadmin" element={<ProtectedAdminRoute><HouseAdmin /></ProtectedAdminRoute>} />
          <Route path="/churchesadmin" element={<ProtectedAdminRoute><ChurchesAdmin /></ProtectedAdminRoute>} />
          <Route path="/shoppingadmin" element={<ProtectedAdminRoute><ShoppingAdmin /></ProtectedAdminRoute>} />



          <Route path="/" element={<HomePage />} />
          <Route path="/places" element={<PlacesPage />} />
          <Route path="/things" element={<ThingsPage />} />
          <Route path="/profile" element={<Profile />} />

          <Route path="/culture" element={<Culture />} />
          <Route path="/community" element={<Community />} />
          <Route path="/festival" element={<Festival />} />


          <Route path="/announcement/:id" element={<AnnouncementDetail />} />



          <Route path="/tulayzapote" element={<TulayZapote />} />
          <Route path="/art-monuments" element={<ArtsMonuments />} />
          <Route path="/molinodam" element={<MolinoDam />} />
          <Route path="/strikegym" element={<StrikeGym />} />
          <Route path="/senyongsmuseum" element={<SenyongsMuseum />} />
          <Route path="/bacoorpark" element={<BacoorPark />} />
          <Route path="/prinzadam" element={<PrinzaDam />} />
          <Route path="/marianogomes" element={<MarianoGomes />} />
          <Route path="/kainanbalsa" element={<KainanBalsa />} />
          <Route path="/seafoodterminal" element={<SeafoodTerminal />} />
          <Route path="/digmanhalo" element={<DigmanHalo />} />
          <Route path="/monumentlove" element={<MonumentLove />} />
          <Route path="/edilbertomonument" element={<EdilbertoMonument />} />
          <Route path="/ginintuan" element={<Ginintuan />} />
          <Route path="/bahaytisa" element={<BahayTisa />} />
          <Route path="/justicehouse" element={<JusticeHouse />} />
          <Route path="/michaelchurch" element={<MichaelChurch />} />
          <Route path="/unidachurch" element={<UnidaChurch />} />
          <Route path="/smbacoor" element={<SMBacoor />} />
          <Route path="/smmolino" element={<SMMolino />} />
          <Route path="/nomo" element={<NOMO />} />
          <Route path="/stonino" element={<StoNino />} />
          <Route path="/somo" element={<SOMO />} />
          <Route path="/stezekiel" element={<StEzekiel />} />
          <Route path="/rfcmall" element={<RFCMall />} />
          <Route path="/mainsquare" element={<MainSquare />} />
          <Route path="/rantonio" element={<RAntonio />} />
          <Route path="/funnside" element={<Funnside />} />
          <Route path="/brickwood" element={<Brickwood />} />
          <Route path="/cocina" element={<Cocina />} />
          <Route path="/cvsu" element={<Cvsu />} />



          <Route
            path="/login"
            element={
              <AuthLayout>
                <Login />
              </AuthLayout>
            }
          />
          <Route
            path="/register"
            element={
              <AuthLayout>
                <SignUp />
              </AuthLayout>
            }
          />
         
        </Routes>
      </div>
    </Router>
  );
};


export default App;
